var map = {
	"./": "d547",
	"./index": "d547",
	"./index.js": "d547",
	"./thunderwaveServer": "d29e",
	"./thunderwaveServer/": "d29e",
	"./thunderwaveServer/dicelist": "9d63",
	"./thunderwaveServer/dicelist.js": "9d63",
	"./thunderwaveServer/dicer": "44e9",
	"./thunderwaveServer/dicer.js": "44e9",
	"./thunderwaveServer/index": "d29e",
	"./thunderwaveServer/index.js": "d29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f387";